import React from 'react';
import { useTheme } from '@stashinvest/ui';

export default ({ width, height }) => {
	const { colors } = useTheme();

	return (
		<svg
			width={width || '26px'}
			height={height || '26px'}
			viewBox="0 0 23 26"
			version="1.1"
		>
			<g stroke="none" fill="none">
				<g
					transform="translate(-258.000000, -353.000000)"
					stroke={colors.iconDefault}
					fill={colors.iconDefault}
				>
					<g transform="translate(235.000000, 328.000000)">
						<g transform="translate(24.000000, 26.000000)">
							<path d="M1.845,23.5418182 C1.4113997,23.5583532 1.04422723,23.234675 1.02,22.8145455 L1.02,17.5418182 C1.02000002,17.0999904 1.38936509,16.7418182 1.845,16.7418182 C2.30063491,16.7418182 2.66999998,17.0999904 2.67,17.5418182 L2.67,22.8 C2.66219192,23.0045079 2.57084755,23.1976131 2.41609624,23.3367614 C2.26134494,23.4759097 2.05588744,23.5496809 1.845,23.5418182 Z" />
							<path d="M7.875,23.5418182 C7.4413997,23.5583532 7.07422723,23.234675 7.05,22.8145455 L7.05,12.8145455 C7.05,12.3727177 7.41936508,12.0145455 7.875,12.0145455 C8.33063492,12.0145455 8.7,12.3727177 8.7,12.8145455 L8.7,22.8 C8.69219192,23.0045079 8.60084755,23.1976131 8.44609624,23.3367614 C8.29134494,23.4759097 8.08588744,23.5496809 7.875,23.5418182 L7.875,23.5418182 Z" />
							<path d="M13.905,23.5418182 C13.4713997,23.5583532 13.1042272,23.234675 13.08,22.8145455 L13.08,15.2218182 C13.08,14.7799904 13.4493651,14.4218182 13.905,14.4218182 C14.3606349,14.4218182 14.73,14.7799904 14.73,15.2218182 L14.73,22.8 C14.7221919,23.0045079 14.6308475,23.1976131 14.4760962,23.3367614 C14.3213449,23.4759097 14.1158874,23.5496809 13.905,23.5418182 Z" />
							<path d="M19.935,23.5418182 C19.5013997,23.5583532 19.1342272,23.234675 19.11,22.8145455 L19.11,9.45454545 C19.11,9.01271765 19.4793651,8.65454545 19.935,8.65454545 C20.3906349,8.65454545 20.76,9.01271765 20.76,9.45454545 L20.76,22.8 C20.7521919,23.0045079 20.6608475,23.1976131 20.5060962,23.3367614 C20.3513449,23.4759097 20.1458874,23.5496809 19.935,23.5418182 L19.935,23.5418182 Z" />
							<path d="M1.32,13.6872727 C1.06875284,13.671207 0.835436633,13.5554532 0.675,13.3672727 C0.21,12.9672727 0.33,12.4363636 0.75,11.9927273 L7.2375,5.01818182 L13.335,7.92727273 L18.96,0.727272727 C19.335,0.247272727 19.815,3.05311332e-16 20.31,0.385454545 C20.805,0.770909091 20.7825,1.14909091 20.4075,1.62909091 L13.7475,10.4290909 L7.5,7.42545455 L2.16,13.1709091 C1.95903722,13.441519 1.65813459,13.6264894 1.32,13.6872727 L1.32,13.6872727 Z" />
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};
